<template>
  <div class="overview">
    <header>
      <button @click="$emit('close')" class="btn"><i class="material-icons">arrow_back</i> <span><strong>Back</strong></span></button>
    </header>
    
    <h1 v-text="scenarioData.name"></h1>

    <div class="panel shadowed">
      <TimelineContainer />

      <ul class="main-list">
        <li v-for="playlist in playlists" :key="playlist.id" :class="{current: playlist.id == playlistId, done: getPlaylistStatus(scenarioId, playlist.id) }">
          <h3 @click="toggleOpen(playlist.id)">
            <div class="gutter">
              <i class="material-icons done" v-if="getPlaylistStatus(scenarioId, playlist.id)">check_circle</i>
              <div class="dot" v-else :class="{current: playlist.id == playlistId }"></div>
              <div class="line" v-if="isOpen(playlist.id)"></div>
            </div>
            <i class="material-icons" v-if="isOpen(playlist.id)">keyboard_arrow_down</i>
            <i class="material-icons" v-else>keyboard_arrow_right</i>
            <span class="title" v-text="playlist.name"></span>
            <span class="decision-count">{{playlist.items.length}} decisions</span>
          </h3>

          <transition name="fade" mode="in-out">
            <ul class="sub-list" v-if="isOpen(playlist.id)">
              <li v-for="inject in playlist.injects" :key="inject" class="inject">
                <div class="gutter">
                  <i class="material-icons dot">fiber_manual_record</i>
                  <div class="line"></div>
                </div>
                <div class="item rounded" @click="$router.push(`/trainee/scenario/${scenarioId}/playlist/${playlist.id}?skipintro=1`)" v-text="getInjectName(inject)"></div>
              </li>

              <li v-for="(item, dindex) in playlist.items" :key="item.id" class="decision" :class="{done: hasResponse(scenarioId, playlist.id, item.id), current: currentItem && currentItem.id === item.id && playlist.id === playlistId }">
                <div class="gutter">
                  <span class="material-icons runner" v-if="currentItem && currentItem.id === item.id && playlist.id === playlistId">directions_walk</span>
                  <i class="material-icons done" v-if="hasResponse(scenarioId, playlist.id, item.id)">check_circle</i>
                  <i class="material-icons dot" v-else>fiber_manual_record</i>
                  <div class="line"></div>
                </div>
                <div class="item rounded" @click="$store.dispatch('traineeStatusModule/setDecisionIndex', dindex); $router.push(`/trainee/scenario/${scenarioId}/playlist/${playlist.id}?d=${dindex}&skipintro=1`)" v-html="item.question.replace('<br>', ' ')"></div>
              </li>

              <li v-if="playlist.outcomes && playlist.outcomes.length > 0" class="outcome">
                <div class="gutter">
                  <i class="material-icons dot">fiber_manual_record</i>
                  <div class="line"></div>
                </div>
                <div class="item rounded" @click="$router.push(`/trainee/scenario/${scenarioId}/playlist/${playlist.id}?outcomes=1&skipintro=1`)">Learning Outcomes</div>
              </li>
            </ul>
          </transition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
import TimelineContainer from '@/components/TimelineContainer.vue';

export default {
  name: 'PlaylistOverview',
  mixins: [scenarioMixin],
  props: ['currentItem'],
  components: {
    TimelineContainer
  },
  data () {
    return {
      opened: []
    }
  },
  created () {
    this.opened.push(this.playlistId)
  },
  computed: {
    playlists () {
      let playlists = []
      this.scenarioData.playlists.forEach(pid => {
        playlists.push(this.$store.getters["scenarioModule/getPlaylist"](pid))
      })
      return playlists
    },
  },
  methods: {
    isOpen (pid) {
      return this.opened.includes(pid)
    },
    toggleOpen (pid) {
      let index = this.opened.indexOf(pid);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(pid)
      }
    },
    getInjectData (id) {
      return this.$store.getters["scenarioModule/getInject"](id);
    },
    getInjectName (id) {
      let injectData = this.getInjectData(id)
      return injectData.name
    },
    hasResponse (sid, pid, id) {
      // return this.responses.has( this.playlistData.items[index].id )
      return this.$store.getters["traineeStatusModule/hasResponseDeep"]({id: id, sid: sid, pid: pid});
    },
    getPlaylistStatus (sid, pid) {
      return this.$store.getters["traineeStatusModule/getPlaylistStatus"]({sid: sid, pid: pid});
    }
  }
}
</script>

<style lang="scss" scoped>
.overview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  background-color: #fff;
  z-index: 999;

  &:before {
    content: " ";
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    background-color: #fff;
    z-index: 9;
    height: 65px;
  }
}
h1 {
  max-width: var(--container-width);
  margin: 25px auto;
  padding: 0 25px;
  color: var(--primary);
  font-size: 21px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media all and (min-width: 980px) {
    font-size: 31px;
  }
}
.panel {
  position: relative;
  max-width: var(--container-width);
  margin: 0 auto;
  border-radius: var(--border-radius);
}
header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--primary);
  height: 65px;
  border-radius: 0px 0px 67px 0px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  
  button {
    color: #fff;
  }
}

.timeline-container {
  position: sticky;
  top: 65px;
  z-index: 10;
  background-color: #fff;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0;
  // margin-right: 20px;
  max-width: calc(100%);
  padding-top: 15px;
  border-radius: var(--border-radius);
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.main-list {
  // padding-left: 40px;
  margin-left: 20px;
  margin-right: 20px;
  transition: all 1s;
  
  & > li {
    border-bottom: 2px solid #e2e8ff;

    &:last-of-type {
      border-bottom: 0;
    }
  }


  h3 {
    position: sticky;
    top: 114px;
    padding: 10px 0;
    background-color: #fff;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.01em;
    color: var(--primary);
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 1;

    .dot {
      width: 19px;
      height: 19px;
      aspect-ratio: 1 / 1;
      border: 2px solid #E2E8FF;
      background-color: #fff;
      border-radius: 50%;

      &.current {
        border: 2px solid var(--primary);
        background-color: var(--primary);
      }
    }
    .done {
      color: #21D64C;
    }
    .line {
      height: 40%;
      bottom: 0;
    }

    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
    .decision-count {
      white-space: nowrap;
      font-weight: normal;
      font-size: 12px;
      margin-left: auto;
    }
  }
}

.gutter {
  min-width: 40px;
  max-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E2E8FF;

  i {
    background-color: #fff;
  }
}
.line {
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: var(--primary);
  z-index: -1;
}
.runner {
  position: absolute;
  left: -15px;
}

.sub-list {
  margin-bottom: 20px;

  li {
    position: relative;
    display: flex;

    &:last-of-type .line {
      height: 50%;
      top: 0;
    }
    
    .item {
      flex: 1;
      padding: 10px;
      background-color: #E2E8FF;
      font-size: 14px;
      font-weight: bold;
      color: var(--primary);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    // &:before {
    //   content: "";
    //   position: absolute;
    //   left: -20px;
    //   width: 9px;
    //   height: 9px;
    //   aspect-ratio: 1 / 1;
    //   background-color: var(--primary);
    // }

    &.done {
      .gutter {
        color: #21D64C;
      }
      .item {
        background-color: #21D64C;
        color: #fff;
      }
    }

    &.inject,
    &.current {
      .gutter {
        color: var(--primary);
      }
      .item {
        background-color: var(--primary);
        color: #fff;
      }
    }
    &.outcome {
      .gutter {
        color: var(--orange);
      }
      .item {
        background-color: var(--orange);
        color: #fff;
      }
    }
  }
  .inject .item {
    // padding: 5px 20px 5px 0;
    margin: 5px 0;

  }
  .decision .item {
    margin: 5px 0 5px 15px;
    // padding: 5px 20px;
  }
}

.dot {
  font-size: 14px;
}
</style>